module.exports = __webpack_public_path__ + "img/29.75f4e537.png";